import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';

import StaticGauge from '../StaticGauge';
import { CircleTooltip } from '../CircleTooltip';

import styles from './styles/ChartWidget.module.scss';

interface ChartWidgetProps {
  title: string;
  description?: string;
  value: number | null;
  tooltip?: ReactElement | string;
  color?: 'yellow' | 'green' | 'red'; // Color prop defined
}

const DefaultTooltip = (
  <>
    <p className={styles.tooltip}>
      A credit union can meet the Target Market test by showing that at least
      60% of its members are part of its Target Market if either of the
      following conditions are met:
    </p>
    <ul className={styles.tooltip__margin}>
      <li className={styles.tooltip}>
        It has directed more than 60% of the number of loans and between 50% and
        60% of the dollar amount of loans to its Target Market; OR
      </li>
      <li className={styles.tooltip}>
        It has directed more than 60% of the dollar amount of loans and between
        50% and 60% of the number of loans to its Target Market.
      </li>
    </ul>
  </>
);

export default function ChartWidget({
  title,
  description,
  value,
  tooltip = DefaultTooltip,
  color,
}: ChartWidgetProps) {
  const isEmptyState = value === null;

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <h1
            className={`${styles.title__text} ${
              isEmptyState ? styles.title__secondary : styles.title__primary
            }`}
          >
            {title}
          </h1>
          {isEmptyState && (
            <CircleTooltip
              description={tooltip}
              fullWidth
              width="264px"
              iconStyle={{ width: '14px', height: '14px' }}
            />
          )}
        </div>

        {description && <p className={styles.description}>{description}</p>}
      </div>
      <div className={styles.value}>
        {!isEmptyState && <StaticGauge progress={value} color={color} />}{' '}
      </div>
    </div>
  );
}

ChartWidget.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.number,
  tooltip: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  color: PropTypes.oneOf(['yellow', 'green', 'red']),
};

ChartWidget.defaultProps = {
  description: undefined,
  tooltip: undefined,
  value: null,
  color: 'green',
};
